/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var NetworkShareIcon = createIcon("NetworkShareIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#171717';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M6.751 5.625a.375.375 0 100 .75.375.375 0 000-.75v0Zm5.25.375h1.5m3 0h1.5m-11.25 5.625a.375.375 0 100 .75.375.375 0 000-.75v0Zm5.25.375h1.5m3 0h1.5m-6 3v6m-7.5 0h15m3.375-.75a.375.375 0 100 .75.375.375 0 000-.75Zm-21.75 0a.375.375 0 100 .75.375.375 0 000-.75Z",
    stroke: _color,
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 6a3 3 0 01-3 3H6a3 3 0 110-6h12a3 3 0 013 3Zm0 6a3 3 0 01-3 3H6a3 3 0 010-6h12a3 3 0 013 3Z",
    stroke: _color,
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}, {
  "replaceColor": true
});